import axios from "axios";
import { BaseMarket } from './baseMarket'
import iconHyperliquid from "@/assets/images/hyperliquid.avif";
import { Wallet, getBytes, Signature, keccak256, BrowserProvider } from 'ethers';
import { encode } from '@msgpack/msgpack';
import { Hyperliquid } from './hyperliquid/index';
import Web3 from 'web3';
import { webSocketObj } from "./utils/websocket"
import { getMarkets } from "@/api/perp";


let apiURL = 'https://api.hyperliquid.xyz'
// let apiURL = 'https://api-ui.hyperliquid.xyz'
let referrerCode = 'ABOARD'

// let hyperliquidChain = 1 ? 'Mainnet' : 'Testnet'
// let signatureChainId = 0 ? '0xa4b1' : '0x66eee'
const hyperliquidChain = 'Mainnet'
const IS_MAINNET = true
class HyperliquidObj extends BaseMarket {
  name = 'Hyperliquid'
  chainCode = 'arbitrum'
  icon = iconHyperliquid
  hasOrderBook = true
  minSize = 10
  defaultSymbol = 'BTC'

  isInit = false
  account = null
  webSocket = null
  sdk

  async init () {
    this.webSocket = new webSocketObj('wss://api.hyperliquid.xyz/ws')
    while (!this.webSocket.isOpen) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    this.webSocketPing()
  }
  async webSocketPing () {
    this.webSocket.send({
      "method": "ping",
      // "subscription": { "type": "allMids" }
    })
    setTimeout(() => {
      this.webSocketPing()
    }, 30 * 1000);
  }

  // constructor() { }
  async initAccount (account) {
    // this.account = '4PkLqzgEMcBKZUiXH9Fxj5poW6WW3B7WoGKPHznTrGnU'
    this.account = account

    let apiWallet = localStorage.getItem(`hyperliquid_agent_${account}`)
    if (!apiWallet) return
    apiWallet = JSON.parse(apiWallet)
    this.sdk = new Hyperliquid({
      enableWs: false,
      privateKey: apiWallet.pk,
      testnet: false,
      walletAddress: account,
      vaultAddress: ''
    });
    try {
      this.sdk.exchange.setReferrer(referrerCode)
    } catch (error) {
      console.log(error)
    }
    this.isInit = true
  }
  async getIsInit () {
    if (this.isInit) return 1
    return await new Promise((r, j) => {
      setTimeout(async () => {
        let k = await this.getIsInit()
        if (k) r(k)
      }, 2000);
    })
  }

  async getFreeCollateral (account) {
    const { data } = await axios.post(`${apiURL}/info`, {
      type: 'clearinghouseState',
      user: account
    })
    if (data.withdrawable) {
      return Number(data.withdrawable)
    }
    return 0
  }


  async getPositions (account, list) {
    let orders = list
    if (!list) {
      const { data } = await axios.post(`${apiURL}/info`, {
        type: 'clearinghouseState',
        user: account
      })
      orders = data.assetPositions
    }
    orders = orders.map(item => {
      const obj = item.position
      let josn = {
        direction: obj.szi < 0 ? 'Short' : 'Long',
        symbol: obj.coin,
        size: Math.abs(+obj.szi),
        // leverage: obj.maxLeverage,
        triggerPrice: +obj.entryPx,
        price: +obj.entryPx,
        liquidationPrice: obj.liquidationPx ? +obj.liquidationPx : 0,
        unrealizedPnl: +obj.unrealizedPnl
      }
      return josn
    })

    return orders.filter(item => item.size)
  }
  async getOpenOrders (account, list) {
    let orders = list
    if (!list) {
      const { data } = await axios.post(`${apiURL}/info`, {
        type: 'frontendOpenOrders',
        user: account
      })
      orders = data
    }
    orders = orders.map(obj => {
      let direction = obj.side == 'A' ? 'Short' : 'Long'

      let josn = {
        symbol: obj.coin,
        flags: obj.reduceOnly ? 'Reduce Only' : '--',
        direction: direction,
        size: +obj.sz,
        sizeUsd: 0,
        triggerPrice: +obj.triggerPx,
        price: obj.orderType.indexOf('Limit') != -1 ? +obj.limitPx : 0,
        orderId: obj.oid,
        orderType: obj.orderType,
        reduceOnly: obj.reduceOnly
      }
      return josn
    })
    return orders
  }
  async getUserTrades (account) {
    const { data } = await axios.post(`${apiURL}/info`, {
      type: 'userFills',
      user: account
    })
    let trades = data.map(item => {
      item.direction = item.takerOrderDirection || item.makerOrderDirection
      let obj = {
        // marketIndex: item.marketIndex,
        symbol: item.coin,
        direction: item.side == 'A' ? 'Long' : 'Short',
        size: +item.sz,
        price: +item.px || 0,
        fee: +item.fee || 0,
        date: parseInt(item.time / 1000),
        tx: item.hash,
        pnl: +item.closedPnl
      }
      return obj
    })
    return trades
  }

  async getLiquidationPrice (params) {


  }
  async calculateFeeForQuoteAmount (params) {
    const { data } = await axios.post(`${apiURL}/info`, {
      type: 'userFees',
      user: params.account
    })
    if (data.userCrossRate) {
      let fees = Number(data.userCrossRate) * (1 - Number(data.activeReferralDiscount)) * params.sizeInUsd

      return Number(fees.toFixed(4))
    }
    return 0

  }

  async getKLine (p) {
    let intervalObj = {
      k1: '1m',
      k5: '5m',
      k15: '15m',
      k30: '30m',
      k60: '1h',
      k1D: '1d',
      k1W: '1d',
      k1M: '1d',
    }
    let { data } = await axios.post(`${apiURL}/info`, {
      type: 'candleSnapshot',
      req: {
        coin: `${p.ticker}`,
        interval: intervalObj[`k${p.interval}`],
        startTime: p.from * 1000,
        endTime: p.to * 1000
      }
    })
    // let list = await this.sdk.info.getCandleSnapshot(`${p.ticker}-PERP`, intervalObj[`k${p.interval}`], p.from * 1000, p.to * 1000, true)
    let list = data.map(item => {
      return {
        time: item.t,

        close: Number(item.c),
        high: Number(item.h),
        low: Number(item.l),
        open: Number(item.o),

        volume: Number(item.v),
      }
    })

    if (p.interval == '1W') {
      let newList = []
      let obj = {}
      list.forEach((item, i) => {
        if (i % 7 == 0) {
          obj = {
            ...item,
            open: obj.close || 0
          }
        } else {
          obj.close = item.close
          obj.high = item.high > obj.high ? item.high : obj.high
          obj.low = item.low < obj.low ? item.low : obj.low
          obj.volume = (Number(obj.volume) + Number(item.volume)) + ''
          if (i == list.length - 1 || i % 7 == 6) {
            newList.push(obj)
          }
        }
      })
      list = newList
    }
    if (p.interval == '1M') {
      let newList = []
      let obj = {}
      list.forEach((item, i) => {
        if (i % 30 == 0) {
          obj = {
            ...item,
            open: obj.close || 0
          }
        } else {
          obj.close = item.close
          obj.high = item.high > obj.high ? item.high : obj.high
          obj.low = item.low < obj.low ? item.low : obj.low
          obj.volume = parseInt(Number(obj.volume) + Number(item.volume)) + ''
          if (i == list.length - 1 || i % 30 == 29) {
            newList.push(obj)
          }
        }
      })
      list = newList
    }

    return list
  }

  async deposit (params, wallet) {
    const usdcAbi = [
      {
        constant: false,
        inputs: [
          { name: "_to", type: "address" },
          { name: "_value", type: "uint256" }
        ],
        name: "transfer",
        outputs: [{ name: "", type: "bool" }],
        type: "function"
      }
    ];

    const toAddress = "0x2Df1c51E09aECF9cacB7bc98cB1742757f163dF7";
    const accounts = await wallet.eth.requestAccounts()
    const usdcContract = new wallet.eth.Contract(usdcAbi, params.address);
    const amountInSmallestUnit = parseInt(Number(params.amount) * (10 ** 6));
    const { transactionHash } = await usdcContract.methods
      .transfer(toAddress, amountInSmallestUnit)
      .send({ from: accounts[0] });
    console.log("Transaction successful:", transactionHash);

    return transactionHash
  }
  async withdraw (params, wallet) {
    const accounts = await wallet.eth.requestAccounts()

    const action = {
      type: 'withdraw3',
      // hyperliquidChain,
      signatureChainId: '0xa4b1',
      destination: accounts[0],
      amount: params.amount + '',
      time: Date.now()
    };

    const signature = await this.signUserSignedAction(
      action,
      [
        { name: 'hyperliquidChain', type: 'string' },
        { name: 'destination', type: 'string' },
        { name: 'amount', type: 'string' },
        { name: 'time', type: 'uint64' },
      ],
      'HyperliquidTransaction:Withdraw'
    )


    const payload = { action, nonce: action.time, signature };
    const { data } = await axios.post(`${apiURL}/exchange`, payload)
    return data
  }
  async getPerpList () {

    let url = `${apiURL}/info`
    const data = await axios.post(url, {
      type: 'metaAndAssetCtxs'
    })
    let sdkList = []
    if (data.data) {
      data.data[0].universe.forEach((item, i) => {
        let obj = data.data[1][i]
        let h24Change = obj.markPx - obj.prevDayPx
        let json = {
          marketType: 'perp',
          oraclePrice: +obj.oraclePx,
          symbol: item.name,
          marketIndex: i,
          price24hAgo: obj.prevDayPx,
          h24Vol: obj.dayNtlVlm,
          star: false,
          priceScale: 2,
          volumeScale: item.szDecimals,
          platform: 'Hyperliquid',
          leverage: item.maxLeverage,
          h24Change: h24Change,
          h24ChangePer: h24Change / obj.prevDayPx * 100,

          openInterest: obj.openInterest * obj.markPx,
          funding: obj.funding * 100,
        }
        sdkList.push(json)
      })
    }


    let apiList = await getMarkets(this.name)
    // if (!apiList || !apiList.length) apiList = sdkList

    let marketStar = localStorage.getItem('marketStar')
    if (marketStar) {
      marketStar = JSON.parse(marketStar)
    } else {
      marketStar = []
    }
    let newDatas = apiList.map((item, i) => {
      let obj = sdkList.find(o => o.symbol == item.symbol)
      if (obj) {
        item.star = marketStar.indexOf(item.symbol) != -1
        let json = {
          ...obj,
          ...item,
        }
        return json
      } else {
        return 0
      }

    })
      // .filter(item => item &&item.h24Vol&& item.icon)
      .filter(item => item)


    return newDatas.sort((a, b) => {
      return (b.star === true) - (a.star === true)
    })
  }

  async getPerpPrice (perpList, callback) {

    this.webSocket.send({
      "method": "subscribe",
      "subscription": { "type": "allMids" }
    })

    this.webSocket.addCallback('getPerpPrice', (msg) => {
      if (msg.channel == "allMids") {
        let objList = {}
        for (const key in msg.data.mids) {
          if (Object.prototype.hasOwnProperty.call(msg.data.mids, key)) {
            const element = msg.data.mids[key];
            objList[key] = {
              h24Change: 0,
              h24ChangePer: 0,
              price: element
            }
          }
        }
        let time = (parseInt((new Date().getTime()) / 1000))
        if (time % 2 == 0) {
          callback(JSON.parse(JSON.stringify(objList)))
        }
      }
      // console.log(999)
    })

  }
  async getSpotPrice (tokenList, callback) {

    return tokenList
  }

  async subscribeOrderBook (coin, callback) {

    let oldCoin = localStorage.getItem(`hyperliquid_icon`)
    if (oldCoin) {
      this.webSocket.send({
        "method": "unsubscribe",
        "subscription": {
          "type": "trades",
          coin: oldCoin
        }
      })
    }

    this.webSocket.send({
      "method": "subscribe",
      "subscription": {
        "type": "l2Book",
        coin
      }
    })
    localStorage.setItem(`hyperliquid_icon`, coin)

    this.webSocket.addCallback('subscribeOrderBook', (msg) => {
      if (msg.channel == "l2Book" && msg.data.coin == coin) {
        let objList = msg.data.levels.map(item => {
          item.time = item.n + msg.data.time
          return item
        })

        let time = (parseInt((new Date().getTime()) / 1000))
        if (time % 2 == 0) {
          callback(JSON.parse(JSON.stringify(objList)), coin)
        }
      }
      // console.log(999)
    })
  }
  async subscribeTrades (coin, callback) {

    let oldCoin = localStorage.getItem(`hyperliquid_icon`)
    if (oldCoin) {
      this.webSocket.send({
        "method": "unsubscribe",
        "subscription": {
          "type": "trades",
          coin: oldCoin
        }
      })
    }

    this.webSocket.send({
      "method": "subscribe",
      "subscription": {
        "type": "trades",
        coin
      }
    })
    localStorage.setItem(`hyperliquid_icon`, coin)

    this.webSocket.addCallback('subscribeTrades', (msg) => {
      if (msg.channel == "trades" && msg.data[0] && msg.data[0].coin == coin) {
        let list = msg.data.map(item => {
          return {
            symbol: item.coin,
            price: item.px,
            side: item.side == 'B' ? 'Long' : 'Short',
            time: item.time,
            size: item.sz,
          }
        })
        callback(list)

        // let time = (parseInt((new Date().getTime()) / 1000))
        // if (time % 2 == 0) {
        //   callback(list)
        // }
      }
    })

  }

  async subscribeUserTrades (user, callback) {

    let oldUser = localStorage.getItem(`hyperliquid_user`)
    if (oldUser) {
      this.webSocket.send({
        "method": "unsubscribe",
        "subscription": {
          "type": "webData2",
          user: oldUser
        }
      })
    }

    this.webSocket.send({
      "method": "subscribe",
      "subscription": {
        "type": "webData2",
        user: user
      }
    })
    localStorage.setItem(`hyperliquid_user`, user)
    this.webSocket.addCallback('subscribeUserTrades', (msg) => {
      if (msg.channel == "webData2") {
        if (msg.data.user && user.toLowerCase() == msg.data.user.toLowerCase()) {
          console.log('openOrders', msg.data.openOrders.length)
          callback({
            positions: msg.data.clearinghouseState.assetPositions,
            orders: msg.data.openOrders
          })
        }
      }
    })
  }

  async getSpotList () {
    return [
      {
        platform: 'Hyperliquid',
        "chainCode": "arbitrum",
        symbol: 'USDC',
        address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        decimals: 6,
        "icon": null,
        balance1: null,
        balance: null,
        scale: 2,
        price: 1
      }
    ]
  }
  async createOrder (params) {
    await this.getIsInit()
    const convertedSymbol = params.symbol + "-PERP";
    let isBuy = params.direction == 'Long'
    if (params.addType == 'close') {
      isBuy = !isBuy
      params.orderType = 'Market'
      params.reduceOnly = true
    }

    const slippage = params.slippage || 0.05
    let arr = []
    if (params.orderType) {
      let px = Number(params.tokenPrice)
      if (params.orderType == 'Limit') {
        px = Number(params.price)
      } else {
        px *= isBuy ? (1 + slippage) : (1 - slippage);
      }
      const orderParams = {
        coin: convertedSymbol,
        is_buy: isBuy,
        sz: +params.size,
        limit_px: +(px.toFixed(params.priceScale)),
        order_type: { limit: { tif: 'Gtc' } },
        reduce_only: params.reduceOnly,
      }
      arr.push(orderParams)
    }
    if (params.takeProfitPrice) {
      let triggerPx = Number((+params.takeProfitPrice).toFixed(8))
      let limit_px = !isBuy ? triggerPx * (1 + slippage) : triggerPx * (1 - slippage);
      let take = {
        coin: convertedSymbol,
        is_buy: !isBuy,
        sz: +params.size,
        limit_px: +(limit_px.toFixed(params.priceScale)),
        order_type: {
          trigger: {
            triggerPx,
            isMarket: true,
            tpsl: 'tp',
          }
        },
        reduce_only: true,
      }
      arr.push(take)
    }
    if (params.stopLossPrice) {
      let triggerPx = Number((+params.stopLossPrice).toFixed(8))
      let limit_px = !isBuy ? triggerPx * (1 + slippage) : triggerPx * (1 - slippage);
      let stop = {
        coin: convertedSymbol,
        is_buy: !isBuy,
        sz: +params.size,
        limit_px: +(limit_px.toFixed(params.priceScale)),
        order_type: {
          trigger: {
            triggerPx,
            isMarket: true,
            tpsl: 'sl',
          }
        },
        reduce_only: true,
      }
      arr.push(stop)
    }

    let res = await this.sdk.exchange.placeOrder({ orders: arr })
    if (res.response && res.response.data && res.response.data.statuses && res.response.data.statuses[0].error) {
      let err = res.response.data.statuses[0].error
      throw new Error(err.split('. ')[0])
    }
    if (res.status == 'err') {
      if (res.response.indexOf('User or API Wallet') != -1 && res.response.indexOf('does not exist.') != -1) {
        let d = await this.approveAgent(params.account)
        if (d == 'ok') {
          return await this.createOrder(params)
        }
      }
      throw new Error(res.response)
    }
    return null
  }


  async approveAgent (account) {

    // These are also known as agent wallets in the docs. 
    // A master account can approve API wallets to sign on behalf of the master account or any of the sub-accounts. 
    const web3 = new Web3()
    const apiWallet = web3.eth.accounts.create();
    const action = {
      type: 'approveAgent',
      hyperliquidChain,
      // signatureChainId: '0xa4b1',
      agentAddress: apiWallet.address,
      agentName: '',
      nonce: Date.now()
    };
    const signature = await this.signUserSignedAction(
      action,
      [
        { name: 'hyperliquidChain', type: 'string' },
        { name: 'agentAddress', type: 'address' },
        { name: 'agentName', type: 'string' },
        { name: 'nonce', type: 'uint64' },
      ],
      'HyperliquidTransaction:ApproveAgent'
    )

    delete action.agentName
    const payload = { action, nonce: action.nonce, signature, isFrontend: true, vaultAddress: null };
    debugger
    const { data } = await axios.post(`${apiURL}/exchange`, payload)
    if (data.status != 'err') {
      localStorage.setItem(`hyperliquid_agent_${account}`, JSON.stringify({
        pk: apiWallet.privateKey,
        ad: account
      }))
      await this.initAccount(account)
      return 'ok'
    } else {
      if(data.response==='IP not allowed'){
        throw new Error('You are accessing our products and services from a restricted jurisdiction. We do not allow access from certain jurisdictions including locations subject to sanctions restrictions and other jurisdictions where our services are ineligible for use.')
      }else{
        throw new Error(data.response)
      }
    }
  }


  async updateOrder (params) {
    await this.getIsInit()

    let order = params.order
    const convertedSymbol = order.symbol + "-PERP";
    let isBuy = order.direction == 'Long'
    const slippage = order.slippage || 0.05

    const orderParams = {
      coin: convertedSymbol,
      is_buy: isBuy,
      sz: +params.size,
      limit_px: order.price || 0,
      order_type: { limit: { tif: 'Gtc' } },
      reduce_only: order.reduceOnly,
    }

    if (order.orderType.indexOf('Limit') != -1) {
      orderParams.limit_px = +params.limitPrice
    }

    if (params.triggerPrice) {
      const triggerPx = +params.triggerPrice
      if (order.orderType.indexOf('Limit') == -1) {
        orderParams.limit_px = isBuy ? triggerPx * (1 + slippage) : triggerPx * (1 - slippage);
      }
      if (order.orderType.indexOf('Take') != -1) {
        orderParams.order_type = {
          trigger: {
            triggerPx: triggerPx,
            isMarket: order.orderType.indexOf('Market') != -1,
            tpsl: 'tp',
          }
        }
      }
      if (order.orderType.indexOf('Stop') != -1) {
        orderParams.order_type = {
          trigger: {
            triggerPx: triggerPx,
            isMarket: order.orderType.indexOf('Market') != -1,
            tpsl: 'sl',
          }
        }
      }
    }

    let res = await this.sdk.exchange.modifyOrder(params.orderId, orderParams)
    if (res.response && res.response.data && res.response.data.statuses && res.response.data.statuses[0].error) {
      let err = res.response.data.statuses[0].error
      throw new Error(err.split('. ')[0])
    }
    if (res.status == 'err') {
      throw new Error(res.response)
    }
    return null
  }
  async cancelOrder (params) {
    await this.getIsInit()
    const convertedSymbol = params.symbol + "-PERP";

    let res = await this.sdk.exchange.cancelOrder({
      coin: convertedSymbol,
      o: params.orderId
    })
    if (res.response && res.response.data && res.response.data.statuses && res.response.data.statuses[0].error) {
      let err = res.response.data.statuses[0].error
      throw new Error(err.split('. ')[0])
    }
    if (res.status == 'err') {
      throw new Error(res.response)
    }
    return null
  }
  async getTokenAmounts (account) {
    const { data } = await axios.post(`${apiURL}/info`, {
      type: 'clearinghouseState',
      user: account
    })
    return [
      {
        symbol: 'USDC',
        balance: +data.marginSummary.accountValue
      }
    ]
  }
  async getTokenAmount (params) {

    return
  }

  async signL1Action (account, action, activePool, nonce, isMainnet) {

    let apiWallet = localStorage.getItem(`hyperliquid_agent_${account}`)
    apiWallet = JSON.parse(apiWallet)
    const wallet = new Wallet(apiWallet.pk);
    const hash = actionHash(action, activePool, nonce);
    const phantomAgent = { source: isMainnet ? 'a' : 'b', connectionId: hash }
    const data = {
      domain: {
        name: 'Exchange',
        version: '1',
        chainId: 42161,
        verifyingContract: '0x0000000000000000000000000000000000000000',
      },
      types: {
        Agent: [
          { name: 'source', type: 'string' },
          { name: 'connectionId', type: 'bytes32' },
        ],
      },
      message: phantomAgent,
    };

    const signature = await wallet.signTypedData(data.domain, data.types, data.message);

    const { r, s, v } = Signature.from(signature);
    return { r, s, v }
  }

  async signUserSignedAction (action, payloadTypes, primaryType) {
    const provider = new BrowserProvider(window.ethereum);
    let wallet1 = await provider.getSigner();
    let chainId = Number(wallet1.provider._network.chainId)
    action.signatureChainId = "0x" + chainId.toString(16);
    action.hyperliquidChain = hyperliquidChain;

    const data = {
      domain: {
        name: 'HyperliquidSignTransaction',
        version: '1',
        chainId: chainId,
        verifyingContract: '0x0000000000000000000000000000000000000000',
      },
      types: {
        [primaryType]: payloadTypes,
      },
      message: action,
    };
    const signature = await wallet1.signTypedData(data.domain, data.types, data.message);
    const { r, s, v } = Signature.from(signature);
    return { r, s, v }
  }
  getApiWallet (account) {
    let apiWallet = localStorage.getItem(`hyperliquid_agent_${account}`)
    if (apiWallet) {
      apiWallet = JSON.parse(apiWallet)
      return apiWallet
    } else {
      return
    }
  }

  async getOrderBook (coin, obj) {
    let orderBooks = obj
    if (!obj) {
      const { data } = await axios.post(`${apiURL}/info`, {
        type: 'l2Book',
        coin: coin,
        nSigFigs: 5,
      })
      orderBooks = data.levels.map(item => {
        item.time = item.n + data.time
        return item
      })

    }
    let list = [orderBooks[1], orderBooks[0]]
    list = list.map((item, i) => {

      let sum = 0
      let listSub = item.map(obj => {
        sum += Number(obj.sz)
        let json = {
          index: i,
          size: obj.sz,
          price: obj.px,
          sum: Number(sum),
        }
        return json
      })
      listSub = listSub.map(obj => {
        obj.percent = parseInt(obj.sum / sum * 100) + '%'
        return obj
      })
      if (!i) listSub.reverse()

      return listSub
    })
    return list
  }
}


function actionHash (action, vaultAddress, nonce) {
  const msgPackBytes = encode(action);
  const additionalBytesLength = vaultAddress === null ? 9 : 29;
  const data = new Uint8Array(msgPackBytes.length + additionalBytesLength);
  data.set(msgPackBytes);
  const view = new DataView(data.buffer);
  view.setBigUint64(msgPackBytes.length, BigInt(nonce), false);
  if (vaultAddress === null) {
    view.setUint8(msgPackBytes.length + 8, 0);
  } else {
    view.setUint8(msgPackBytes.length + 8, 1);
    data.set(getBytes(vaultAddress), msgPackBytes.length + 9);
  }
  return keccak256(data);
}



export const hyperliquidObj = new HyperliquidObj()